/* Search drawer v2 + time-specific search message (Figma 6-5477).
   Moved from snippets/search-drawer.liquid so the ~11KB ships once,
   cached, instead of inline in every page's HTML (branch perf audit).
   Config arrives via data-* attributes on [data-search-drawer]. */
(function () {
  var root = document.querySelector('[data-search-drawer]');
  if (!root || root.dataset.sd2Init) return;
  root.dataset.sd2Init = 'true';

  // Time-of-day slogan for the navbar pill + drawer placeholder.
  // Loaded with defer, so the DOM (incl. the pill) is already parsed.
  var spMsgs = {
    morning: root.dataset.spMorning || '',
    afternoon: root.dataset.spAfternoon || '',
    evening: root.dataset.spEvening || '',
    night: root.dataset.spNight || ''
  };
  var h = new Date().getHours();
  var spMsg = h >= 5 && h < 12 ? spMsgs.morning
    : h >= 12 && h < 17 ? spMsgs.afternoon
    : h >= 17 && h < 21 ? spMsgs.evening
    : spMsgs.night;
  if (spMsg) {
    document.querySelectorAll('.nav2-search-pill__text').forEach(function (el) { el.textContent = spMsg; });
    document.querySelectorAll('[data-sd2-input]').forEach(function (el) { el.placeholder = spMsg; });
  }

    var panelInput = root.querySelector('[data-sd2-input]');
    var clearBtn = root.querySelector('[data-sd2-clear]');
    var form = root.querySelector('[data-sd2-form]');
    var idleView = root.querySelector('[data-sd2-idle]');
    var resultsView = root.querySelector('[data-sd2-results]');
    var zeroView = root.querySelector('[data-sd2-zero]');
    var suggestionsEl = root.querySelector('[data-sd2-suggestions]');
    var productsEl = root.querySelector('[data-sd2-products]');
    var countEl = root.querySelector('[data-sd2-count]');
    var showAll = root.querySelector('[data-sd2-showall]');
    var termEls = root.querySelectorAll('[data-sd2-term], [data-sd2-zero-term]');
    var moneyFormat = root.dataset.moneyFormat || '£{{amount}}';
    var searchUrl = root.dataset.searchUrl || '/search';
    var predictiveUrl = root.dataset.predictiveUrl || '/search/suggest';
    var debounceTimer = null;
    var lastQuery = '';

    function money(value) {
      var amount = parseFloat(value);
      if (isNaN(amount)) return value;
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount.toFixed(2));
    }

    function clearThemeSearchClasses() {
      // theme.js headerNav.searchDrawer() adds these for the old overlay
      // (now removed) — they dim/lock the page, so always strip them.
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
    }

    var tilesEl = root.querySelector('[data-sd2-tiles]');
    var tilesLoaded = false;

    function renderAutoTiles(products) {
      products.slice(0, 4).forEach(function (p) {
        if (!p || !p.images || !p.images.length) return;
        var a = document.createElement('a');
        a.className = 'sd2__tile';
        a.href = p.url || ('/products/' + p.handle);
        var img = document.createElement('img');
        img.className = 'sd2__tile-img';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = p.title || '';
        var base = p.images[0].src;
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        img.src = base + sep + 'width=480';
        img.srcset = base + sep + 'width=240 240w, ' + base + sep + 'width=380 380w, ' + base + sep + 'width=480 480w, ' + base + sep + 'width=560 560w';
        img.sizes = '(max-width: 664px) 189px, 231px';
        var shade = document.createElement('span');
        shade.className = 'sd2__tile-shade';
        shade.setAttribute('aria-hidden', 'true');
        var label = document.createElement('span');
        label.className = 'sd2__tile-label';
        label.textContent = p.title || '';
        a.appendChild(img); a.appendChild(shade); a.appendChild(label);
        tilesEl.appendChild(a);
      });
    }

    function loadTiles() {
      // Manual tile settings win; otherwise pull the best-sellers collection
      // (same source + in-stock filter + session cache as main's old search).
      if (tilesLoaded || !tilesEl || tilesEl.children.length > 0) { tilesLoaded = true; return; }
      tilesLoaded = true;
      var handle = tilesEl.dataset.sd2TilesCollection;
      if (!handle) return;
      try {
        var cached = sessionStorage.getItem('sd2-best-sellers-v2');
        if (cached) { renderAutoTiles(JSON.parse(cached)); return; }
      } catch (e) {}
      fetch('/collections/' + handle + '/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products ? data.products : []).filter(function (p) {
            return p && p.variants && p.variants.some(function (v) { return v.available; });
          });
          if (!products.length) return;
          // Cache only what renderAutoTiles reads — the raw payload includes
          // body_html and every variant/image (tens of KB per product).
          var slim = products.slice(0, 8).map(function (p) {
            return {
              title: p.title,
              url: p.url,
              handle: p.handle,
              images: p.images && p.images.length ? [{ src: p.images[0].src }] : []
            };
          });
          try { sessionStorage.setItem('sd2-best-sellers-v2', JSON.stringify(slim)); } catch (e) {}
          renderAutoTiles(slim);
        })
        .catch(function () { /* tiles stay empty */ });
    }

    function open() {
      clearThemeSearchClasses();
      root.hidden = false;
      // Forced reflow instead of rAF: still animates the slide-in, but works
      // in hidden/background tabs where rAF callbacks never fire.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.documentElement.classList.add('sd2-lock');
      // Legacy listeners (e.g. the cart-added toast) hide themselves on this
      // event — keep dispatching it so the toast still auto-hides.
      document.dispatchEvent(new CustomEvent('predictive-search:open', { bubbles: true }));
      loadTiles();
      // Re-sync on every open: the drawer can close without resetting the
      // field (Escape / X), and bfcache restores can desync button vs value.
      clearBtn.hidden = panelInput.value.trim().length === 0;
      window.setTimeout(function () { panelInput.focus(); }, 320);
    }
    function close() {
      clearThemeSearchClasses();
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sd2-lock');
      window.setTimeout(function () { root.hidden = true; }, 300);
    }

    function setView(state) {
      idleView.hidden = state !== 'idle';
      resultsView.hidden = state !== 'results';
      zeroView.hidden = state !== 'zero';
    }

    function setTerm(q) {
      termEls.forEach(function (el) { el.textContent = q; });
      showAll.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
    }

    // ── Hover second image (same behaviour as product cards) ──
    // The predictive API only returns the featured image, so the second
    // image is fetched lazily from /products/<handle>.js on first hover of
    // a card (cached per handle for the session). Like the product cards,
    // the swap only reveals once the image has loaded — until then the
    // primary image keeps showing (never a blank/white flash).
    var canHoverCards = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hoverImageCache = {}; // handle -> Promise<secondImageUrl|null>

    function secondImageFor(productUrl) {
      var handle;
      try {
        handle = new URL(productUrl, window.location.origin).pathname.split('/').pop();
      } catch (e) { return Promise.resolve(null); }
      if (!handle) return Promise.resolve(null);
      if (!hoverImageCache[handle]) {
        hoverImageCache[handle] = fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (prod) {
            return (prod && prod.images && prod.images.length > 1) ? prod.images[1] : null;
          })
          .catch(function () { return null; });
      }
      return hoverImageCache[handle];
    }

    // Warm /products/<handle>.js for the freshly rendered result cards during
    // idle time, so the second image is already cached before the first hover
    // (measured ~420ms fetch latency otherwise). Predictive returns ≤9 cards,
    // all visible; capped at 10 and deduped through the same per-handle cache
    // secondImageFor uses, so hover never refetches. Hover-capable only —
    // touch devices never show the swap.
    function prefetchHoverImages(products) {
      if (!canHoverCards || !products || !products.length) return;
      var run = function () {
        products.slice(0, 10).forEach(function (p) {
          if (p && p.url) secondImageFor(p.url);
        });
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        window.setTimeout(run, 300);
      }
    }

    function attachHoverImage(card, product) {
      card.addEventListener('mouseenter', function onEnter() {
        card.removeEventListener('mouseenter', onEnter);
        secondImageFor(product.url).then(function (src) {
          if (!src || !card.isConnected) return;
          var media = card.querySelector('.sd2__card-media');
          if (!media) return;
          var sep = src.indexOf('?') > -1 ? '&' : '?';
          var img = document.createElement('img');
          img.className = 'sd2__card-hover';
          img.decoding = 'async';
          img.alt = '';
          img.src = src + sep + 'width=480';
          img.srcset = src + sep + 'width=240 240w, ' + src + sep + 'width=360 360w, ' + src + sep + 'width=480 480w, ' + src + sep + 'width=720 720w';
          img.sizes = '(max-width: 768px) 45vw, 340px';
          // Reveal only once loaded — mirrors the product cards'
          // secondary-image--loaded gate.
          if (img.complete && img.naturalWidth > 0) {
            img.classList.add('is-loaded');
          } else {
            img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          }
          media.appendChild(img);
        });
      });
    }

    function render(data, q) {
      var res = (data.resources && data.resources.results) || {};
      var products = res.products || [];
      var queries = res.queries || [];

      if (!products.length && !queries.length) {
        setTerm(q);
        setView('zero');
        return;
      }

      suggestionsEl.innerHTML = '';
      queries.slice(0, 6).forEach(function (item) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sd2__suggestion';
        b.innerHTML = item.styled_text || item.text;
        b.addEventListener('click', function () {
          panelInput.value = item.text;
          query(item.text);
        });
        suggestionsEl.appendChild(b);
      });

      productsEl.innerHTML = '';
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'sd2__card';
        a.href = p.url;
        var imgBase = (p.featured_image && p.featured_image.url) || p.image || '';
        a.innerHTML =
          '<span class="sd2__card-media">' + (imgBase ? '<img loading="lazy" decoding="async" alt="">' : '') + '</span>' +
          '<span class="sd2__card-title"></span>' +
          '<span class="sd2__card-colour"></span>' +
          '<span class="sd2__card-price"></span>';
        if (imgBase && canHoverCards) attachHoverImage(a, p);
        if (imgBase) {
          var cardSep = imgBase.indexOf('?') > -1 ? '&' : '?';
          var cardImg = a.querySelector('img');
          cardImg.src = imgBase + cardSep + 'width=480';
          // Cards render ~330px wide in the default 2-col layout of the
          // 720px-max panel — ~660 device px on retina. The old 480w
          // ceiling (with sizes=226px) forced an upscale and soft images.
          cardImg.srcset = imgBase + cardSep + 'width=240 240w, ' + imgBase + cardSep + 'width=360 360w, ' + imgBase + cardSep + 'width=480 480w, ' + imgBase + cardSep + 'width=720 720w';
          cardImg.sizes = '(max-width: 768px) 45vw, 340px';
          cardImg.alt = p.title || '';
        }
        a.querySelector('.sd2__card-title').textContent = p.title || '';
        a.querySelector('.sd2__card-colour').textContent = p.vendor || '';
        a.querySelector('.sd2__card-price').textContent = money(p.price);
        productsEl.appendChild(a);
      });

      countEl.textContent = '(' + products.length + ')';
      setTerm(q);
      setView('results');
      prefetchHoverImages(products);
    }

    var inflight = null;

    function query(q) {
      lastQuery = q;
      clearBtn.hidden = q.length === 0;
      if (q.length < 2) {
        // Cancel any in-flight request when the query shrinks below the
        // threshold — otherwise a stale response could paint over 'idle'.
        if (inflight) { inflight.abort(); inflight = null; }
        setView('idle');
        return;
      }
      var url = predictiveUrl + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query' +
        // Single knob for how many results the drawer shows: the grid
        // renders every product returned, and limit_scope=each caps the
        // query suggestions to the same number.
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=hide' +
        // tag is load-bearing: DFYNE colours live in product tags, so colour
        // queries ("red") return 0 products without it (verified against
        // /search/suggest.json — 0 vs 9 products for q=red).
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      if (inflight) inflight.abort();
      inflight = new AbortController();
      fetch(url, { headers: { 'Accept': 'application/json' }, signal: inflight.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (q === lastQuery) render(data, q); })
        .catch(function () { /* aborted or network error — keep current view */ });
    }

    panelInput.addEventListener('input', function () {
      var q = panelInput.value.trim();
      // Visibility tracks the field synchronously — inside the debounced
      // query() it lagged 250ms and could stick visible on an empty field.
      clearBtn.hidden = q.length === 0;
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () { query(q); }, 250);
    });

    // Already on the search results page: route the new query through the
    // page's collection-grid AJAX engine so only the results area refreshes
    // (header/toolbar/nav stay mounted). Anywhere else, fall through to the
    // normal form navigation — the results section isn't in the DOM to swap.
    // Empty the search field once a query is committed, so the input never
    // lingers showing the last term (on the results page or on reopen).
    function resetInput() {
      panelInput.value = '';
      clearBtn.hidden = true;
      setView('idle');
    }

    function inPageSearch(q) {
      if (window.location.pathname !== searchUrl) return false;
      var grid = window.theme && theme.activeCollectionGrid;
      if (!grid || typeof grid.runSearch !== 'function') return false;
      if (!grid.container || !grid.container.isConnected) return false;
      grid.runSearch(q);
      close();
      resetInput();
      return true;
    }

    form.addEventListener('submit', function (evt) {
      var q = panelInput.value.trim();
      if (q.length === 0) { evt.preventDefault(); return; }
      if (!inPageSearch(q)) {
        // Native navigation path: clear the field AFTER the browser has
        // serialised the form. Clearing synchronously here emptied the
        // input before GET serialisation, so every Enter search submitted
        // q= and landed on a blank results page.
        window.setTimeout(resetInput, 0);
      } else {
        evt.preventDefault();
      }
    });

    showAll.addEventListener('click', function (evt) {
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      var q = panelInput.value.trim();
      if (!q) return;
      if (inPageSearch(q)) evt.preventDefault();
      else resetInput();
    });

    clearBtn.addEventListener('click', function () {
      panelInput.value = '';
      clearBtn.hidden = true;
      setView('idle');
      panelInput.focus();
    });

    root.querySelectorAll('[data-sd2-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keyup', function (evt) {
      if (!root.isConnected) return; // stale instance after section re-render
      if (evt.key === 'Escape' && !root.hidden) close();
    });

    root.querySelectorAll('[data-sd2-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        panelInput.value = pill.textContent.trim();
        query(pill.textContent.trim());
        panelInput.focus();
      });
    });

    root.querySelectorAll('[data-sd2-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-sd2-cols]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        productsEl.classList.remove('sd2__products--2', 'sd2__products--3');
        productsEl.classList.add('sd2__products--' + btn.dataset.sd2Cols);
        try { sessionStorage.setItem('sd2Cols', btn.dataset.sd2Cols); } catch (e) {}
      });
    });
    try {
      var savedCols = sessionStorage.getItem('sd2Cols');
      if (savedCols) {
        var btn = root.querySelector('[data-sd2-cols="' + savedCols + '"]');
        if (btn) btn.click();
      }
    } catch (e) {}

    // Opening the cart (or nav) drawer while the search panel is up left the
    // sd2 panel + backdrop sitting underneath the theme drawer, so the cart
    // appeared over a white search panel instead of the standard page dim.
    // Close the search drawer whenever a theme drawer trigger is clicked.
    document.addEventListener('click', function (evt) {
      if (!root.isConnected || root.hidden) return;
      var drawerTrigger = evt.target && evt.target.closest
        ? evt.target.closest('.js-drawer-open-cart, .js-drawer-open-nav')
        : null;
      if (drawerTrigger) close();
    }, true);

    // Capture phase: runs BEFORE theme.js's element-level .js-search-header
    // handler (which calls stopPropagation + opens the removed old overlay).
    document.addEventListener('click', function (evt) {
      if (!root.isConnected) return; // stale instance after section re-render
      if (evt.button !== 0 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      var trigger = evt.target && evt.target.closest ? evt.target.closest('.js-search-header') : null;
      if (!trigger) return;
      evt.preventDefault();
      evt.stopPropagation();
      open();
    }, true);
  })();
